<template>
  <div>
    <NovaPoshtaHead
        :showFilter="showFilter"
        :countFilterParams="countFilterParams"
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @reload="$emit('reload')"
        @selectAll="selectAll"
    />

    <div class="table-filter-wrap">

      <NovaPoshtaFilter
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          @close="closeFilter"
          @changeFilter="data => $emit('changeFilter', data)"
          @resetFilter="$emit('resetFilter')"
      />

      <NovaPoshtaTable
          :countFilterParams="countFilterParams"
          :selectedNow="selectedNow"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import NovaPoshtaHead from "./NovaPoshtaHead/NovaPoshtaHead";
  import NovaPoshtaFilter from "./NovaPoshtaFilter/NovaPoshtaFilter";
  import NovaPoshtaTable from "./NovaPoshtaTable/NovaPoshtaTable";

  export default {
    name: "NovaPoshtaTableUser",

    components: {
      NovaPoshtaHead,
      NovaPoshtaFilter,
      NovaPoshtaTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
        selectedNow: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      selectAll(val) {
        this.selectedNow = val
      },

    }
  }
</script>

<style scoped>

</style>
